import { Injectable } from '@angular/core';
import { ApiResponseModel } from '../shared/models/api-response.model';
import { HttpClient } from '@angular/common/http';
import { User } from '../shared/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient) {}

  login(body) {
    return this.http.post<ApiResponseModel<LoginType>>('/api/auth/login', body);
  }

  forgetPassword(body) {
    return this.http.post<ApiResponseModel>('/api/auth/forget', body);
  }

  resetPassword(body) {
    return this.http.post<ApiResponseModel>('/api/auth/reset', body);
  }

  register(body) {
    return this.http.post<ApiResponseModel>('/api/auth/register', body);
  }

  refreshToken(body) {
    return this.http.post<ApiResponseModel>('/api/auth/refresh', body);
  }
  resendVerification() {
    return this.http.get<ApiResponseModel>('api/auth/resend');
  }
  verifyUserMail() {
    return this.http.get<ApiResponseModel>('api/auth/verify');
  }
}
export interface LoginType {
  user: User;
  token: string;
  role: 'Admin' | 'Local' | 'Traveler';
}
